import { TuiSkeleton } from '@taiga-ui/kit';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  AppVersionData,
  AppVersionService,
} from '@core/services/app-version.service';
import { BehaviorSubject, tap } from 'rxjs';
import { DeviceDetectorService, IsLoadingService } from '@core/services';
import { AccountService } from '@core/services/account/account.service';
import { AsyncPipe, NgClass } from '@angular/common';

@Component({
  selector: 'x-app-version',
  templateUrl: './app-version.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TuiSkeleton, AsyncPipe, NgClass],
})
export class AppVersionComponent implements OnInit {
  readonly accountService = inject(AccountService);
  readonly user$ = this.accountService.currentUser$;
  readonly deviceService = inject(DeviceDetectorService);
  readonly isLoading$: BehaviorSubject<boolean> = inject(IsLoadingService);
  private readonly appVersionService = inject(AppVersionService);
  private readonly destroyRef = inject(DestroyRef);

  $appVersionData: WritableSignal<AppVersionData | null> = signal(null);

  ngOnInit() {
    this.appVersionService.appVersionData$
      .pipe(
        tap(data => this.$appVersionData.set(data)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(this.$appVersionData);
  }
}
